import { InfoPopover as _InfoPopover } from './info-popover';
import { InfoPopoverBody, InfoPopoverLink, InfoPopoverList } from './info-popover.parts';
import { InfoPopoverSection, InfoPopoverTitle } from './info-popover.parts';

const InfoPopover = Object.assign(_InfoPopover, {
  Title: InfoPopoverTitle,
  Body: InfoPopoverBody,
  Section: InfoPopoverSection,
  List: InfoPopoverList,
  Link: InfoPopoverLink,
});

export type { InfoPopoverProps } from './info-popover';
export { InfoPopover };
